import { type PropsWithChildren } from 'react';

export interface PaperSectionProps extends PropsWithChildren {
  title: string;
}

export default function PaperSection(props: Readonly<PaperSectionProps>) {
  const { title, children } = props;

  return (
    <div className='flex w-full flex-col rounded-2xl bg-white shadow-md'>
      <div className='flex items-center justify-between px-6 py-4'>
        <h3>{title}</h3>
      </div>
      <hr className='border-border-divider' />
      {children}
    </div>
  );
}
